/**
 * Alert Manager - Token Validation Alert Controller
 *
 * Provides a non-Redux mechanism to trigger a global alert when
 * the JWT token expires or becomes invalid (401 response from API).
 * The App component registers its setShowAlert function here,
 * and saga middleware calls showTokenValidationAlert on 401 errors.
 *
 * Flow: API returns 401 -> Saga calls AlertManager.showTokenValidationAlert()
 *       -> SimpleAlert component displays re-login prompt
 */

/** Reference to the App component's alert state setter */
let showAlertFunction: ((show: boolean) => void) | null = null;

/** Registers the alert display function (called once in App.tsx on mount) */
export const setShowAlertFunction = (showAlertFn: (show: boolean) => void) => {
	showAlertFunction = showAlertFn;
};

/** Triggers the token expiration alert (called from sagas on 401 responses) */
export const showTokenValidationAlert = () => {
	if (showAlertFunction) {
		showAlertFunction(true);
	}
};

/** Hides the token expiration alert */
export const hideAlert = () => {
	if (showAlertFunction) {
		showAlertFunction(false);
	}
};

const AlertManager = {
	setShowAlertFunction,
	showTokenValidationAlert,
	hideAlert,
};

export default AlertManager;
